<template>
  <div
    v-if="subHeader"
    class="our-team-banner"
  >
    <div class="our-team-banner__image-wrapper">
      <img
        v-if="subHeader.picture"
        v-bind="subHeader.picture"
        @load="handlerImageLoad"
        usemap="#workmap"
        class="our-team-banner__image"
      >
      <div
        v-if="activeModalKey !== null && screenWidth >= 1024"
        :style="{ left:  cordsModal[activeModalKey][0] + 'px', top: cordsModal[activeModalKey][1] + 'px' }"
        class="our-team-message"
      >
        <h5 class="our-team-message__title">
          {{ activeMember.name }}
        </h5>
        <p class="our-team-message__position">
          {{ activeMember.worckPosition }}
        </p>
        <div
          v-html="activeMember.short_description"
          class="our-team-message__text"
        />
      </div>
    </div>
    <map name="workmap">
      <area
        v-for="(item, key) in coords"
        shape="rect"
        :coords="item.toString()"
        class="our-team-banner__area"
        @click="openModal"
        @mouseover="activeModalKey = key"
        @mouseleave="activeModalKey = null"
      >
    </map>
  </div>
</template>

<script>
import { reactive, ref, computed } from 'vue';
import { useAModal } from "../ui";
import { useHeader } from "../../composables/useHeader";
import { useTeam } from "../../composables/useTeam";
import { useScreenWidth } from "../../composables/useScreenWidth";

export default {
  name: 'OurTeamBanner',
  props: ['result'],
  setup() {
    const { team, setActiveMember } = useTeam();
    const { screenWidth } = useScreenWidth();

    const {subHeader} = useHeader();
    const activeModalKey = ref(null);
    const coords = reactive([
      [348, 641, 648, 2074],
      [711, 737, 1078, 2000],
      [1159, 700, 1481, 1952],
      [1585, 704, 1878, 2089],
      [1922, 604, 2300, 1774],
      [2315, 667, 2941, 2122],
    ]);
    const cordsModal = reactive([
      [182, 1011],
      [679, 1573],
      [1113, 1011],
      [1508, 1573],
      [1961, 1011],
      [2305, 1573],
    ]);
    const activeMember = computed(() => activeModalKey.value !== null &&  team.value[activeModalKey.value]);

    const handlerImageLoad = ({ target }) => {
      class ImageMap {
        constructor(img, coords, cordsModal) {
          this.img = img;
          this.previousWidth = img.naturalWidth;
          this.coords = coords;
          this.cordsModal = cordsModal;
        }

        resizeArray = (coords, x) => {
          coords.forEach(arr => {
            arr.forEach((el, key) => {
              arr[key] *= x;
            });
          });
        }

        resize = function () {
          let x = this.img.offsetWidth / this.previousWidth;

          this.resizeArray(this.coords, x);
          this.resizeArray(this.cordsModal, x);

          this.previousWidth = this.img.offsetWidth;
          return true;
        };
      }

      let imageMap = new ImageMap(target, coords, cordsModal);
      imageMap.resize();

    };

    const modal = useAModal();

    const openModal = () => {
      if (screenWidth >= 1024) {
        setActiveMember(activeMember.value);
        modal.show('team-member');
      }
    }

    return {
      subHeader,
      handlerImageLoad,
      team,
      coords,
      activeModalKey,
      cordsModal,
      openModal,
      activeMember,
      // screenWidth,
    }
  }
}
</script>

<style lang="scss" scoped>
.our-team-banner {
  display: flex;
  &__image-wrapper{
    display: inline-block;
    position: relative;
    margin: 0 auto;
  }
  &__image{
    display: inline-block;
  }
  &__area{
    cursor: pointer;
  }
}
.our-team-message{
  position: absolute;
  background: #FFFFFF;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 24px 30px;
  max-width: 353px;
  pointer-events: none;
  &__title{
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
  }
  &__position{
    font-size: 12px;
    line-height: 16px;
    color: #00A59E;
    margin-bottom: 24px;
  }
  &__text{
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0;
  }
}
</style>